module.exports = __webpack_public_path__ + "static/media/studio_construction_telehandler_mt_930h_manitou_005.94569dca.png";